import { render, staticRenderFns } from "./ConsumerRegistrationPage.vue?vue&type=template&id=b71cf516&scoped=true"
import script from "./ConsumerRegistrationPage.vue?vue&type=script&lang=js"
export * from "./ConsumerRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./ConsumerRegistrationPage.vue?vue&type=style&index=0&id=b71cf516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71cf516",
  null
  
)

export default component.exports